import { render, staticRenderFns } from "./IconSvgTHYROIDNewsFeed.vue?vue&type=template&id=8ff5cb00&scoped=true&"
import script from "./IconSvgTHYROIDNewsFeed.vue?vue&type=script&lang=js&"
export * from "./IconSvgTHYROIDNewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff5cb00",
  null
  
)

export default component.exports